import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	ACS_SCHEDULE_FILTER_EVENT,
	ACS_SCHEDULE_FOCUS_EVENT,
	ACS_SCHEDULE_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['profile.acs_schedules']);

/**
 * Open the ACS Schedule accordion on the Templates page.
 *
 * Event-based rather than a DOM click, the way the SSID Template and
 * SSID Schedule sections on this page already are: the page owns which
 * accordion is expanded, and it scrolls the panel into view before it
 * reports back. Retried until the page mounts, so arriving here from
 * another route works as well as already standing on it.
 *
 * @return {Promise<void>} completion acknowledgement
 */
export function openAcsScheduleSection() {
	return openResourceSection(
		ACS_SCHEDULE_SECTION_EVENT,
		'profile.acs_schedules',
		SECTIONS,
	);
}

/**
 * Filter the ACS Schedule table to a search term.
 *
 * The table asks Canvas for the matching page rather than filtering the
 * rows it happens to be showing, so a profile on any page is findable.
 *
 * @param {string} query search text
 * @return {Promise<void>} acknowledgement
 */
export function applyAcsScheduleFilter(query) {
	return dispatchAcknowledgedEvent(ACS_SCHEDULE_FILTER_EVENT, {
		query: String(query || '').trim(),
		resource: 'acs_schedule',
	});
}

/**
 * Point at one ACS Schedule's row in the table.
 * @param {string} entityId profile identifier
 * @return {Promise<void>} acknowledgement
 */
export function focusAcsSchedule(entityId) {
	if (!entityId) return Promise.reject(new Error('invalid_acs_schedule_focus'));
	return dispatchAcknowledgedEvent(ACS_SCHEDULE_FOCUS_EVENT, {
		entityId: String(entityId),
		resource: 'acs_schedule',
	});
}
